import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { JSONTree } from 'react-json-tree';

function Success() {
    const navigate = useNavigate();
    const location = useLocation();
    const responseData = location.state?.responseData;

    return (
        <div className="gi-mobile-card">
            <div className="gi-app-header">
                <div className="gi-brand">
                    <img src="/icons/icon-192x192.png" alt="IDENNTITY" className="gi-brand-icon" />
                    <span>IDENNTITY<span className="gi-brand-dot">.</span></span>
                </div>
            </div>

            <div className="gi-card-content" style={{ justifyContent: 'center' }}>
                <div className="gi-success-check">
                    ✓
                </div>

                <h1 className="gi-title">Verification Successful!</h1>
                <p className="gi-subtitle">
                    Congratulations! Your identity has been verified successfully.
                </p>

                {responseData && (
                    <div className="gi-details-card" style={{ maxHeight: '180px', overflowY: 'auto' }}>
                        <span className="gi-details-key" style={{ display: 'block', marginBottom: '8px' }}>
                            Payload Response:
                        </span>
                        <JSONTree data={responseData} hideRoot invertTheme={false} theme={{
                            tree: { backgroundColor: 'transparent' },
                            base00: 'transparent',
                            base07: 'var(--gi-text-main)',
                            base08: '#EF4444',
                            base0B: '#10B981',
                            base0D: '#f59e0b'
                        }} />
                    </div>
                )}

                <div className="gi-action-area" style={{ marginTop: '24px' }}>
                    <button
                        className="gi-btn-primary"
                        onClick={() => navigate('/')}
                    >
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Success;